import React from 'react';
import {
  CircleRadioWrapper,
  CircleRadioLabel,
  CircleRadioInput,
  CircleRadioSpan,
} from './styles';

const CircleRadioButton = props => (
  <CircleRadioWrapper {...props}>
    <CircleRadioLabel {...props}>
      <CircleRadioInput {...props} type="radio" />
      <CircleRadioSpan {...props} />
    </CircleRadioLabel>
  </CircleRadioWrapper>
);

export default CircleRadioButton;